import React, { Component } from 'react'
import styles from './BBPicture.module.css'

import FormRenderer, {
  componentTypes,
  validatorTypes,
} from '@data-driven-forms/react-form-renderer'
import {
  componentMapper,
  FormTemplate,
} from '@data-driven-forms/mui-component-mapper'

export default class BBDForm extends Component {
  state = {
    schema: {
      fields: [
        {
          component: componentTypes.TEXT_FIELD,
          name: 'voornaam',
          label: 'voornaam',
          validate: [{ type: validatorTypes.REQUIRED }],
        },
        {
          component: componentTypes.TEXT_FIELD,
          name: 'achternaam',
          label: 'achternaam',
        },
        {
          component: componentTypes.CHECKBOX,
          name: 'adres',
          label: 'adres of zoiets',
        },
        {
          component: componentTypes.CHECKBOX,
          name: 'adres2',
          label: 'adres of zoiets v22',
        },
        {
          component: componentTypes.DATE_PICKER,
          name: 'datepicker',
          label: 'datum of zoiets',
        },
        {
          component: componentTypes.SWITCH,
          name: 'iets3',
          label: 'datum of zoiets',
        },
        {
          component: componentTypes.SELECT,
          name: 'iets34',
          label: 'datum of zoiets',
          options: [
            {
              label: 'Dogs',
              value: '1',
            },
            {
              label: 'Cats',
              value: '2',
            },
            {
              label: 'Hamsters',
              value: '3',
            },
          ],
        },
        {
          component: componentTypes.SLIDER,
          name: 'iets35',
          label: 'datum of zoiets',
        },
      ],
    },
  }

  /*BUTTON: "button"
CHECKBOX: "checkbox"
DATE_PICKER: "date-picker"
DUAL_LIST_SELECT: "dual-list-select"
FIELD_ARRAY: "field-array"
INPUT_ADDON_BUTTON_GROUP: "input-addon-button-group"
INPUT_ADDON_GROUP: "input-addon-group"
PLAIN_TEXT: "plain-text"
RADIO: "radio"
SELECT: "select"
SLIDER: "slider"
SUB_FORM: "sub-form"
SWITCH: "switch"
TABS: "tabs"
TAB_ITEM: "tab-item"
TEXTAREA: "textarea"
TEXT_FIELD: "text-field"
TIME_PICKER: "time-picker"
WIZARD: "wizard"
*/

  static getDescription() {
    return {
      name: 'BBDForm',
      component: BBDForm,
      label: 'BBDForm',
      variables: [
        {
          name: 'title',
          type: 'text',
          label: 'Titel boven de form',
        },
        {
          name: 'class',
          type: 'text',
          label: 'uri van de owl/shacl classe',
        },
        {
          name: 'query',
          type: 'yasgui',
          label:
            'to fill the form. Use title,uri, propUri, label,value, type (xsd,select), optionLabel optionValue ?required regex, multiple,objectOfCls ',
        },
        {
          name: 'nocancelbutton',
          type: 'boolean',
          label: 'do not show  cancel button.',
        },
        {
          name: 'submit',
          type: 'select',
          label: 'submit handling ',
          options: [
            { label: 'none', value: 'none' },
            { label: 'internal parameters', value: 'internalparameters' },
            { label: 'submit to sparql endpoint', value: 'sparqlendpoint' },
            { label: 'javascript', value: 'javascript' },
          ],
        },
      ],
    }
  }

  shouldComponentUpdate2(arg, arg2) {
    this.getSchema()
    return true
  }

  getSchema() {
    var schema = { fields: [] }
    if (this.props.data == null) {
      return null
    }

    var item_def = {}
    var id_def = {}
    schema.props = item_def
    schema.propsID = id_def
    var volgorde = []
    for (var i in this.props.data.results.bindings) {
      var binding = this.props.data.results.bindings[i]
      var propUri = encodeURIComponent(binding.propUri.value)

      var o = item_def[propUri]
      //  console.log(propUri,binding.propUri.value,item_def);

      var label = binding.label.value
      var type = 'text-field'

      if (o == null) {
        var id = 'id' + volgorde.length
        o = { id: id }
        item_def[propUri] = o
        volgorde.push(o)
        id_def[id] = o
        o.propuri = propUri
        o.component = componentTypes.TEXT_FIELD
        o.name = id
        o.label = label
        try {
          o.initialValue = binding.value.value
        } catch (ee) {}
      }
      try {
        if (binding.required.value === true) {
          o.validate = [{ type: validatorTypes.REQUIRED }]
        }
      } catch (e) {}

      //selects
      try {
        var option = binding.option.value
        o.noOptionsMessage = 'no options found'
        if (o.options == null) {
          o.options = []
          o.component = 'select'
          o.simpleValue = true
        }
        if (binding.optionUri == null) {
          o.options.push({ label: option, value: option })
          o.dataType = 'string'
          o.datatype2 = 'string' // case sensitive
        } else {
          var optionUri = encodeURIComponent(binding.optionUri.value)
          o.options.push({ label: option, value: optionUri })
        }
      } catch (error) {}
      if (o.options == null) {
        //datatype
        try {
          type = binding.datatype.value.replace(
            'http://www.w3.org/2001/XMLSchema#',
            ''
          )

          if (type === 'int') {
            type = 'integer'
          }
          if (type === 'decimal') {
            type = 'float'
          }
          if (
            type === 'integer' ||
            type === 'string' ||
            type === 'float' ||
            type === 'boolean'
          ) {
            o.dataType = type
            o.datatype2 = type
          } else {
            if (type === 'date' || type === 'dateTime') {
              o.component = 'date-picker'
              o.datatype2 = type
            }
          }
          console.log(o)
          //  o.dataType=type
        } catch (ee) {}
      }
    }

    // console.log(binding,propUri);

    schema.volgorde = volgorde
    schema.fields = volgorde
    //this.setState({schema:schema});
    return schema
  }

  onSubmit = (waardes) => {
    var r = { props: {} }

    if (this.props.submit === 'internalparameters') {
      for (var id in waardes) {
        this.props.publish(id, waardes[id])
        console.log('submitting internal values ', id, waardes[id])
      }

      return
    }

    for (const id in waardes) {
      var propdef = this.state.schema.propsID[id]

      var uri = decodeURIComponent(propdef.propuri)
      var waarde = waardes[id]
      //
      var foundType = false
      if (propdef.datatype2 == null) {
        waarde = '<' + decodeURIComponent(waarde) + '>'
        foundType = true
      }
      if (
        propdef.dataType === 'boolean' ||
        propdef.datatype === 'int' ||
        propdef.dataType === 'float' ||
        propdef.dataType === 'string' ||
        propdef.dataType === 'integer' ||
        propdef.datatype2 === 'dateTime' ||
        propdef.datatype2 === 'date' ||
        propdef.datatype2 === 'time'
      ) {
        // on purpose case sensitve
        foundType = true
        waarde =
          '"' +
          waarde +
          '"^^<http://www.w3.org/2001/XMLSchema#' +
          propdef.dataType +
          '>'
      }

      if (foundType === false) {
        alert('unsupported datatype found in form ')
        console.log(
          'unsupported datatype found in form ' + propdef.dataType,
          propdef
        )
        return
      }
      r.props[uri] = { value: waarde, def: propdef }
    }

    console.log(r)
  }
  onCancel(iets) {
    console.log(this, iets)
  }

  render() {
    //console.log(this.props.data);

    //if (this.props.data==null){return null;}
    let schema = this.getSchema()
    let buttons = this.props.nocancelbutton
    if (buttons == null) {
      buttons = false
    }
    //let schema = this.state.schema;
    if (schema == null) {
      return null
    }

    return (
      <div className={styles.main}>
        {this.props.title && (
          <div className={styles.title}>{this.props.title}</div>
        )}
        <FormRenderer
          schema={schema}
          componentMapper={componentMapper}
          FormTemplate={FormTemplate}
          onSubmit={this.onSubmit}
          {...(buttons && { onCancel: this.onCancel })}
        />
      </div>
    )
  }
}
